import { TOGGLE_INSTA_ORDER_CREATE_MODAL, TOGGLE_INSTA_BULK_ORDER_MODAL, TOGGLE_INSTA_VIRTUAL_ACCOUNT_MODAL } from "../constants/action-types";

const initialState = {
  showCreateOrderModal: false,
  showBulkOrderModal: false,
  showVirtualAccountModal: false
}

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_INSTA_ORDER_CREATE_MODAL:
      return { ...state, showCreateOrderModal: !state.showCreateOrderModal };
    case TOGGLE_INSTA_BULK_ORDER_MODAL:
      return { ...state, showBulkOrderModal: !state.showBulkOrderModal };
    case TOGGLE_INSTA_VIRTUAL_ACCOUNT_MODAL:
      return  {...state, showVirtualAccountModal: !state.showVirtualAccountModal}
    default:
      return state;
  }
}

export default uiReducer;
